var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialchannelLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.51 13.13c-0.2-0.23-0.41-0.43-0.65-0.59-0.45-0.32-0.98-0.49-1.53-0.49h-4.94c-1.75 0-3.18 1.78-3.18 3.96s1.43 3.96 3.18 3.96h2.1c0.45 1.030 1.060 1.93 1.79 2.64h-3.9c-2.93 0-5.3-2.96-5.3-6.6s2.38-6.6 5.3-6.6h4.94c0.080 0 0.15 0 0.22 0.020 0.45 0.010 0.89 0.11 1.31 0.27 1.1 0.41 2.040 1.25 2.7 2.36 0.18 0.28 0.33 0.57 0.46 0.88 0.12 0.28 0.23 0.57 0.3 0.88 0.21 0.69 0.31 1.43 0.31 2.2s-0.11 1.51-0.31 2.2h-1.93c-0.13 0-0.27-0.020-0.39-0.050 0.33-0.62 0.51-1.35 0.51-2.15 0-0.79-0.18-1.53-0.51-2.15-0.13-0.27-0.29-0.52-0.48-0.74zM18.44 22.61h-1.050c-0.070 0-0.15 0-0.22-0.020-0.45-0.010-0.9-0.11-1.31-0.26-1.090-0.41-2.040-1.25-2.7-2.36-0.18-0.28-0.33-0.57-0.45-0.88-0.12-0.28-0.23-0.57-0.3-0.88-0.21-0.69-0.31-1.43-0.31-2.2s0.11-1.51 0.31-2.2h1.93c0.13 0 0.26 0.020 0.39 0.050-0.32 0.62-0.51 1.36-0.51 2.15s0.19 1.53 0.51 2.15c0.14 0.27 0.3 0.51 0.49 0.73 0.19 0.23 0.4 0.42 0.64 0.59 0.45 0.31 0.97 0.49 1.53 0.49h4.95c1.75 0 3.18-1.78 3.18-3.96s-1.43-3.96-3.18-3.96h-2.090c-0.45-1.040-1.070-1.94-1.8-2.64h3.9c2.93 0 5.3 2.96 5.3 6.6s-2.38 6.6-5.3 6.6h-3.91z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialchannelLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/socialchannel-link.99aaf5ff1608095b1429473efb54be7e.svg";